import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AutoLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Authenticating...');

  useEffect(() => {
    const exchangeAndRedirect = async (token) => {
      try {
        // Exchange the token for an httpOnly auth_token cookie
        await axios.post(
          `${API}/auth/exchange-token`,
          { token },
          { withCredentials: true }
        );
        setStatus('Logged in. Redirecting...');
        window.location.href = '/';
      } catch (err) {
        setStatus(err.response?.data?.detail || 'Invalid token.');
      }
    };

    const token = searchParams.get('token');
    if (token) {
      exchangeAndRedirect(token);
      return;
    }

    // Bootstrap key + email flow — backend sets cookie directly
    const key = searchParams.get('key');
    const email = searchParams.get('email');
    if (key && email) {
      axios
        .get(`${API}/admin/auto-login`, {
          params: { bootstrap_key: key, email },
          withCredentials: true,
        })
        .then(() => {
          setStatus('Logged in. Redirecting...');
          window.location.href = '/';
        })
        .catch((err) => {
          setStatus(err.response?.data?.detail || 'Auto-login failed.');
        });
      return;
    }

    setStatus('Missing parameters. Use ?key=...&email=... or ?token=...');
  }, [searchParams, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'system-ui' }}>
      <p data-testid="auto-login-status">{status}</p>
    </div>
  );
}
